export default {
  projects: [
    {
      title: 'Worldwide Broker Network',
      shortTitle: 'WBN',
      description:
        'International website and web-based portal for a global network',
      content: ``,
      url: 'https://wbnglobal.com',
      screenshots: [
        require('@/assets/img/screenshots/WBN1.jpg'),
        require('@/assets/img/screenshots/WBN2.jpg'),
        require('@/assets/img/screenshots/WBN3.jpg'),
      ],
      icon: require('@/assets/img/wbn-icon.jpg'),
    },
    {
      title: 'Edco Distributing',
      shortTitle: 'Edco',
      description: 'Marketing and eCommerce site',
      content: ``,
      url: 'https://edcodistributing.com',
      screenshots: [
        require('@/assets/img/screenshots/Edco1.jpg'),
        require('@/assets/img/screenshots/Edco2.jpg'),
        require('@/assets/img/screenshots/Edco3.jpg'),
        require('@/assets/img/screenshots/Edco4.jpg'),
      ],
      icon: require('@/assets/img/edco-icon.jpg'),
    },
    {
      title: 'Coloma Resort',
      shortTitle: 'Coloma',
      description:
        'The best camping and outdoor education on the American River',
      content: ``,
      url: 'https://colomaresort.com',
      screenshots: [
        require('@/assets/img/screenshots/Coloma1.jpg'),
        require('@/assets/img/screenshots/Coloma2.jpg'),
        require('@/assets/img/screenshots/Coloma3.jpg'),
        require('@/assets/img/screenshots/Coloma4.jpg'),
      ],
      icon: require('@/assets/img/coloma-icon.jpg'),
    },
    {
      title: 'Moksa Brewing',
      shortTitle: 'Moksa',
      description: 'Marketing site, eCommerce, and digital menu management',
      content: ``,
      url: 'https://moksabrewing.com',
      screenshots: [
        require('@/assets/img/screenshots/Moksa1.jpg'),
        require('@/assets/img/screenshots/Moksa2.jpg'),
        require('@/assets/img/screenshots/Moksa3.jpg'),
        require('@/assets/img/screenshots/Moksa4.jpg'),
      ],
      icon: require('@/assets/img/moksa-icon.jpg'),
    },
    {
      title: 'R+H Medicine',
      shortTitle: 'R+H',
      description: 'Marketing site',
      content: ``,
      url: 'https://rhmedicine.com/',
      screenshots: [
        require('@/assets/img/screenshots/RH1.jpg'),
        require('@/assets/img/screenshots/RH2.jpg'),
        require('@/assets/img/screenshots/RH3.jpg'),
        require('@/assets/img/screenshots/RH4.jpg'),
      ],
      icon: require('@/assets/img/RH-icon.jpg'),
    },
    {
      title: 'SD Truck World',
      shortTitle: 'SD',
      description: 'Marketing site',
      content: ``,
      url: 'https://sdtruckworld.com/',
      screenshots: [
        require('@/assets/img/screenshots/SD3.jpg'),
        require('@/assets/img/screenshots/SD1.jpg'),
        require('@/assets/img/screenshots/SD2.jpg'),
        require('@/assets/img/screenshots/SD4.jpg'),
      ],
      icon: require('@/assets/img/SD-icon.jpg'),
    },
    {
      title: "Worker's Comp Quote",
      shortTitle: 'CompQuote',
      description: 'Insurance quote calculator',
      content: ``,
      url: 'https://workerscomppricingnow.com/',
      screenshots: [
        require('@/assets/img/screenshots/Workers1.jpg'),
        require('@/assets/img/screenshots/Workers2.jpg'),
        require('@/assets/img/screenshots/Workers3.jpg'),
      ],
      icon: require('@/assets/img/workers-icon.jpg'),
    },
  ],
  members: [
    {
      name: 'Jamison Mergens',
      role: 'Sales/Design',
      saying: 'Hey guys, I have an idea...',
    },
    {
      name: 'Josh',
      role: 'Back-end/Data Architect',
      saying: 'This ERM is beautiful',
    },
    {
      name: 'Rose',
      role: 'Back-end Developer',
      saying: 'Checkout, commit, push',
    },
    {
      name: 'Everton',
      role: 'Front-end Developer',
      saying: "Sure, I'll take a crack at that",
    },
    {
      name: 'Ollie',
      role: 'Front-end Developer',
      saying: "It'll work great!",
    },
    {
      name: 'Tommy',
      role: 'Native App Developer',
      saying: 'Say more with less.',
    },
    {
      name: 'Jeremy',
      role: 'Photography',
      saying: 'No stock shots!',
    },
  ],
}
